module.exports = __webpack_public_path__ + "static/media/default_avatar.26a38e3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/default_avatar.svg
// module id = 187
// module chunks = 0